import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { modeFavicon } from '../../mode-nevek';
import { SzamlazoService } from '../szamlazo.service';

/*  SZÁMLÁZÓ – kezdőlap: a képernyők csempéi és a cég rövid összesítője az évre (kiállított
 *  számlák, kintlévőség, nyitott díjbekérők, NAV-hibák). */
interface Csempe { cim: string; leiras: string; ikon: string; ut: string; }

@Component({
  selector: 'app-szamlazo-kezdolap',
  templateUrl: './kezdolap.component.html',
  styleUrls: ['./kezdolap.component.scss'],
})
export class SzamlazoKezdolapComponent implements OnInit, OnDestroy {
  ikon = modeFavicon('SZAMLAZO');
  readonly csempek: Csempe[] = [
    { cim: 'Számlák', leiras: 'Kiállítás, sztornó, NAV Online Számla adatszolgáltatás', ikon: 'receipt-outline', ut: '/szamlazo/szamlak' },
    { cim: 'Díjbekérők', leiras: 'Fizetési felszólítás; befizetés után számla belőle', ikon: 'document-text-outline', ut: '/szamlazo/dijbekerok' },
    { cim: 'Árajánlat, megrendelés, szállítólevél', leiras: 'A bizonylatlánc: egymásból egy gombbal, a végén számla', ikon: 'cube-outline', ut: '/szamlazo/arajanlatok' },
    { cim: 'Kintlévőségek', leiras: 'Rendezetlen tételek, késedelem, kiegyenlítések listája', ikon: 'time-outline', ut: '/szamlazo/kintlevosegek' },
    { cim: 'Kassza', leiras: 'Bolti eladás: kosár, bruttó árak, nyugta egy kattintással', ikon: 'cart-outline', ut: '/szamlazo/kassza' },
    { cim: 'Nyugták', leiras: 'Kiadott nyugták, érvénytelenítés, napi NAV-adatszolgáltatás', ikon: 'receipt', ut: '/szamlazo/nyugtak' },
    { cim: 'Vevők', leiras: 'Vevőtörzs, adószám-ellenőrzés a NAV-nál', ikon: 'people-outline', ut: '/szamlazo/vevok' },
    { cim: 'Cikktörzs', leiras: 'Cikkszám, vonalkód, egységár, ÁFA-kulcs, gyári számos cikkek', ikon: 'pricetags-outline', ut: '/szamlazo/termekek' },
    { cim: 'Beállítások', leiras: 'Kibocsátó adatai, számlatömbök, NAV, ügyfél-hozzáférés', ikon: 'settings-outline', ut: '/szamlazo/beallitasok' },
  ];
  ossz: { db: number; brutto: number; nyitott: number; dijbekero: number; navHiba: number } | null = null;
  private sub?: Subscription;
  constructor(public sz: SzamlazoService, private router: Router) {}

  async ngOnInit() { await this.sz.init(); this.sub = this.sz.aktiv$.subscribe(() => this.osszesit()); }
  ngOnDestroy() { this.sub?.unsubscribe(); }
  async osszesit() {
    const u = this.sz.aktiv.ugyfelId;
    if (!u) { this.ossz = null; return; }
    try {
      const r: any = await this.sz.get(`/szamlak/${u}?tipus=szamla,storno,dijbekero&ev=${this.sz.aktiv.ev}`);
      const l: any[] = r.szamlak || [];
      const kiall = l.filter((s) => s.tipus !== 'dijbekero' && s.allapot !== 'piszkozat');
      this.ossz = {
        db: kiall.filter((s) => s.tipus === 'szamla').length,
        brutto: kiall.reduce((n, s) => n + Number(s.brutto || 0), 0),
        nyitott: l.filter((s) => s.tipus === 'szamla' && s.allapot === 'kiallitva' && !s.kiegyenlitve).reduce((n, s) => n + Number(s.brutto || 0), 0),
        dijbekero: l.filter((s) => s.tipus === 'dijbekero' && s.allapot === 'kiallitva').length,
        navHiba: l.filter((s) => s.nav_allapot === 'hiba').length,
      };
    } catch { this.ossz = null; }
  }
  nyit(c: Csempe) { this.router.navigateByUrl(c.ut); }
  szam(v: number) { return Number(v || 0).toLocaleString('hu-HU', { maximumFractionDigits: 0 }); }
}
